import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { map, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { RememberScrollPosition } from '../services/scroll-position.service';

@Directive({
  standalone: false,
  selector: '[rememberScrollPosition]'
})
export class RememberScrollPositionDirective implements AfterViewInit, OnDestroy {
  @Input({ required: true }) rememberScrollPositionUUID: string;
  @Input({ required: true }) rememberScrollPositionUrl: string;

  @HostListener('scroll', ['$event'])
  onElementScroll(): void {
    this.service.savePosition(this.el.nativeElement.scrollTop, this.rememberScrollPositionUUID);
  }

  subscription = new Subscription();

  constructor(private el: ElementRef, private service: RememberScrollPosition, private router: Router) {
  }


  ngAfterViewInit() {
    this.subscription.add(this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map(e => e.url)
      ).subscribe(route => {
        if (route === this.rememberScrollPositionUrl) {
          setTimeout(() => {
            this.el.nativeElement.scrollTop = this.service.scrollPositions(this.rememberScrollPositionUUID);
          }, 0);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
